module.exports = __webpack_public_path__ + "img/itx-swap.e2b0d1b9.svg";